import type { WizardState, WizardAction } from "./wizardTypes";
import { STEP_ORDER } from "./wizardTypes";

export const initialState: WizardState = {
  step: "questionnaire",
  answers: { needs: [], volumes: {} },
  plan: null,
  toSales: false,
  payment: null,
  account: null,
};

export function wizardReducer(
  state: WizardState,
  action: WizardAction,
): WizardState {
  switch (action.type) {
    case "SUBMIT_QUESTIONNAIRE": {
      // Plan is now computed server-side and passed in the action payload
      const plan = action.plan;
      return {
        ...state,
        answers: action.answers,
        plan,
        toSales: plan.overCardLimit,
        step: "plan",
      };
    }

    case "CONFIRM_PLAN":
      return { ...state, step: "payment" };

    case "SUBMIT_PAYMENT":
      return {
        ...state,
        payment: action.payment,
        account: action.account,
        step: "confirmation",
      };

    case "GO_TO_STEP": {
      const targetIdx = STEP_ORDER.indexOf(action.step);
      const currentIdx = STEP_ORDER.indexOf(state.step);
      // Only allow going back to previous steps, not forward
      if (targetIdx >= currentIdx || state.step === "confirmation") return state;
      return { ...state, step: action.step };
    }

    default:
      return state;
  }
}
